/**
 * Sentry bootstrap. Imported as the very first module in `index.ts` so the JS
 * and native SDKs are running before Expo Router, providers or any screen
 * module loads -- an error thrown while those modules evaluate is otherwise
 * lost, because the native crash handler only starts once `Sentry.init` runs.
 *
 * The DSN comes from `constants.ts` per environment and is undefined for
 * `local`, which keeps dev noise out of the shared project. The Sentry
 * environment is `DEPLOYMENT_ENVIRONMENT` from the same file: Metro only
 * inlines `EXPO_PUBLIC_*`, so `EAS_BUILD_*` variables are undefined at
 * runtime. `release` is left to the SDK default (bundle id@version+build).
 */
import * as Sentry from "@sentry/react-native";

import { tagSentryRuntime } from "./app-updates/sentry-tags";
import {
  DEPLOYMENT_ENVIRONMENT,
  SENTRY_APP_DSN,
} from "./constants";

const isProduction = process.env.NODE_ENV === "production";
const ignoreErrors = [
  "Network request failed",
  "ResizeObserver loop limit exceeded",
  "ChunkLoadError",
  // Injected by in-app browsers and extensions, not our code.
  "Object Not Found Matching Id",
  // A cancelled fetch (navigation, unmount, timeout).
  "signal is aborted without reason",
];

if (SENTRY_APP_DSN) {
  Sentry.init({
    dsn: SENTRY_APP_DSN,
    tracesSampleRate: isProduction ? 0.1 : 0,
    environment: DEPLOYMENT_ENVIRONMENT,
    ignoreErrors,

    sendDefaultPii: false,
    enableLogs: true,

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    integrations: [Sentry.mobileReplayIntegration()],
  });
  tagSentryRuntime();

}
